module.exports = __webpack_public_path__ + "static/img/coffeeprint.2051843.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/prints/coffeeprint.jpg
// module id = 5nZC
// module chunks = 1